module.exports = __webpack_public_path__ + "img/icons_30.3de10b86.png";